import { boot } from 'quasar/wrappers'

export default boot(async ({ router, store }) => {
  await store.dispatch('auth/init')

  router.beforeEach((to, _, next) => {
    const is402 = to.path === '/402'
    if (store.getters['subscription/blocked'] !== is402) {
      next(is402 ? { name: 'login' } : '/402')
      return
    }
    const is403 = to.path === '/403'
    const is423 = to.path === '/423'
    const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    const requiresAdmin = to.matched.some(record => record.meta.requiresAdmin)
    const { loggedIn } = store.state.auth
    if (requiresAuth && !loggedIn) next({ name: 'login' })
    else if (!requiresAuth && loggedIn && !is403 && !is423) next({ name: requiresAdmin && !store.getters['auth/isAdmin'] ? 'recalls' : 'dashboard' })
    else next()
  })
})
